import { keepPreviousData, skipToken, useQuery } from '@tanstack/react-query';
import { orpc } from 'src/api/rpc/client';

/**
 * Hook to fetch an email thread by conversation ID.
 *
 * Split-child documents (documents with a parentDocumentId) are excluded
 * from each email's documentAssociations; pass includeSplitDocuments to
 * also fetch them in splitDocumentAssociations.
 */
export function useEmailThread(
  conversationId: string | null,
  includeSplitDocuments = false,
) {
  return useQuery({
    ...orpc.communications.emailThreads.getThread.queryOptions({
      input: conversationId
        ? {
            conversationId,
            includeSplitDocuments,
          }
        : skipToken,
    }),
    // Keep showing the already-loaded thread while the split-documents
    // refetch is in flight (the flag changes the query key).
    placeholderData: includeSplitDocuments ? keepPreviousData : undefined,
  });
}
